/**
 * 📎 Models for the shared file upload component
 */

/** 🔥 Represents an uploaded file item, optionally with base64 data */
export interface EcmFileUploadItem {
    file: File;
    base64data?: string;
}

/** 🔥 Possible file upload validation error types */
export type EcmFileUploadError = 'maxFiles' | 'maxSize' | 'invalidType' | 'duplicate';

/** 🔥 Custom error messages keyed by error type */
export type EcmFileUploadErrorMessages = Partial<Record<EcmFileUploadError, string>>;

/** 📬 Default French error messages for file upload validation */
export const DEFAULT_FILE_UPLOAD_ERROR_MESSAGES: Record<EcmFileUploadError, string> = {
    maxFiles: 'Le nombre maximum de fichiers est atteint.',
    maxSize: 'La taille totale des fichiers dépasse la limite autorisée.',
    invalidType: "Le format du fichier n'est pas autorisé.",
    duplicate: 'Ce fichier a déjà été ajouté.',
};
